import React, { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Reportes = () => {
  // Estado para el rango de fechas seleccionado
  const [rangoSeleccionado, setRangoSeleccionado] = useState("7d");
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [mostrarSelector, setMostrarSelector] = useState(false);

  // Productos más vendidos
  const productosTop = [
    { nombre: "Vestido de Verano", categoria: "Ropa", unidades: 150, ingresos: "$7,500" },
    { nombre: "Auriculares Inalámbricos", categoria: "Electrónica", unidades: 120, ingresos: "$6,000" },
    { nombre: "Manta Acogedora", categoria: "Hogar", unidades: 100, ingresos: "$5,000" },
    { nombre: "Novela Misterio", categoria: "Libros", unidades: 80, ingresos: "$2,000" },
    { nombre: "Set de Bloques de Construcción", categoria: "Juguetes", unidades: 70, ingresos: "$1,500" },
  ];

  // Opciones de rango de fechas
  const rangos = [
    { id: "7d", etiqueta: "Últimos 7 días" },
    { id: "mes", etiqueta: "Este mes" },
    { id: "anio", etiqueta: "Este año" },
  ];

  // Función para exportar a Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(
      productosTop.map((p) => ({
        Producto: p.nombre,
        Categoría: p.categoria,
        "Unidades Vendidas": p.unidades,
        Ingresos: p.ingresos,
      }))
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ProductosTop");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "reportes_productos.xlsx");
  };

  return (
    <div className="flex-1 p-6">
      {/* Botón de descarga */}
      <div className="mb-6 flex justify-end">
        <button
          onClick={exportToExcel}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
        >
          Descargar Excel
        </button>
      </div>

      {/* Selección de rango de fechas */}
      <div className="mb-6 flex items-center gap-4">
        <div className="flex items-center bg-gray-800 rounded-md p-1">
          {rangos.map((r) => (
            <button
              key={r.id}
              onClick={() => setRangoSeleccionado(r.id)}
              className={`px-4 py-2 rounded-md text-sm font-medium ${
                rangoSeleccionado === r.id
                  ? "bg-primary text-white"
                  : "text-gray-400 hover:bg-white/10"
              }`}
            >
              {r.etiqueta}
            </button>
          ))}
        </div>

        {/* Rango personalizado */}
        <div className="relative">
          <button
            onClick={() => setMostrarSelector(!mostrarSelector)}
            className="flex items-center gap-2 bg-gray-800 hover:bg-white/10 text-white font-medium py-2 px-4 rounded-md"
          >
            <span className="material-symbols-outlined">calendar_today</span>
            <span>Rango personalizado</span>
          </button>

          {mostrarSelector && (
            <div className="absolute mt-2 z-10 bg-gray-900 p-4 rounded shadow-lg">
              <div className="flex gap-2 items-center">
                <DatePicker
                  selected={fechaInicio}
                  onChange={(date) => setFechaInicio(date)}
                  selectsStart
                  startDate={fechaInicio}
                  endDate={fechaFin}
                  placeholderText="Fecha inicio"
                  className="p-2 rounded bg-gray-800 text-white"
                />
                <span>–</span>
                <DatePicker
                  selected={fechaFin}
                  onChange={(date) => setFechaFin(date)}
                  selectsEnd
                  startDate={fechaInicio}
                  endDate={fechaFin}
                  minDate={fechaInicio}
                  placeholderText="Fecha fin"
                  className="p-2 rounded bg-gray-800 text-white"
                />
              </div>
              <button
                onClick={() => setMostrarSelector(false)}
                className="mt-2 bg-blue-600 hover:bg-blue-700 text-white py-1 px-3 rounded"
              >
                Aplicar
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Paneles de métricas */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        {/* Ventas por categoría */}
        <div className="bg-gray-800/50 rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-1">Ventas por Categoría de Producto</h3>
          <p className="text-3xl font-bold">$25,000</p>
          <div className="flex items-center gap-2 text-sm text-green-500">
            <span className="material-symbols-outlined text-base">arrow_upward</span>
            <span>+15% respecto al mes pasado</span>
          </div>
          <div className="mt-6 h-60 flex items-end gap-4 justify-center px-4">
            <div className="flex flex-col items-center gap-2 w-1/5 h-full">
              <div className="w-full bg-primary/20 rounded-t-md" style={{ height: "10%" }}></div>
              <p className="text-xs text-gray-400">Ropa</p>
            </div>
            <div className="flex flex-col items-center gap-2 w-1/5 h-full">
              <div className="w-full bg-primary/20 rounded-t-md" style={{ height: "70%" }}></div>
              <p className="text-xs text-gray-400">Electrónica</p>
            </div>
            <div className="flex flex-col items-center gap-2 w-1/5 h-full">
              <div className="w-full bg-primary/20 rounded-t-md" style={{ height: "30%" }}></div>
              <p className="text-xs text-gray-400">Hogar</p>
            </div>
            <div className="flex flex-col items-center gap-2 w-1/5 h-full">
              <div className="w-full bg-primary/20 rounded-t-md" style={{ height: "20%" }}></div>
              <p className="text-xs text-gray-400">Libros</p>
            </div>
            <div className="flex flex-col items-center gap-2 w-1/5 h-full">
              <div className="w-full bg-primary/20 rounded-t-md" style={{ height: "80%" }}></div>
              <p className="text-xs text-gray-400">Juguetes</p>
            </div>
          </div>
        </div>

        {/* Ingresos mensuales */}
        <div className="bg-gray-800/50 rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-1">Ingresos Mensuales</h3>
          <p className="text-3xl font-bold">$120,000</p>
          <div className="flex items-center gap-2 text-sm text-green-500">
            <span className="material-symbols-outlined text-base">arrow_upward</span>
            <span>+8% respecto al año pasado</span>
          </div>
          <div className="mt-6 h-64">
            <svg fill="none" height="100%" preserveAspectRatio="none" viewBox="0 0 472 150" width="100%" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 109C18.1538 109 18.1538 21 36.3077 21C54.4615 21 54.4615 41 72.6154 41C90.7692 41 90.7692 93 108.923 93C127.077 93 127.077 33 145.231 33C163.385 33 163.385 101 181.538 101C199.692 101 199.692 61 217.846 61C236 61 236 45 254.154 45C272.308 45 272.308 121 290.462 121C308.615 121 308.615 149 326.769 149C344.923 149 344.923 1 363.077 1C381.231 1 381.231 81 399.385 81C417.538 81 417.538 129 435.692 129C453.846 129 453.846 25 472 25V149H0V109Z" fill="url(#paint0_linear_chart)"></path>
              <path d="M0 109C18.1538 109 18.1538 21 36.3077 21C54.4615 21 54.4615 41 72.6154 41C90.7692 41 90.7692 93 108.923 93C127.077 93 127.077 33 145.231 33C163.385 33 163.385 101 181.538 101C199.692 101 199.692 61 217.846 61C236 61 236 45 254.154 45C272.308 45 272.308 121 290.462 121C308.615 121 308.615 149 326.769 149C344.923 149 344.923 1 363.077 1C381.231 1 381.231 81 399.385 81C417.538 81 417.538 129 435.692 129C453.846 129 453.846 25 472 25" stroke="var(--primary-color)" strokeLinecap="round" strokeWidth="2"></path>
              <defs>
                <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_chart" x1="236" x2="236" y1="1" y2="149">
                  <stop stopColor="var(--primary-color)" stopOpacity="0.3"></stop>
                  <stop offset="1" stopColor="var(--primary-color)" stopOpacity="0"></stop>
                </linearGradient>
              </defs>
            </svg>
            <div className="flex justify-between text-xs text-gray-400 mt-2">
              <span>Ene</span><span>Feb</span><span>Mar</span><span>Abr</span><span>May</span><span>Jun</span>
              <span>Jul</span><span>Ago</span><span>Sep</span><span>Oct</span><span>Nov</span><span>Dic</span>
            </div>
          </div>
        </div>
      </div>

      {/* Tabla de productos top */}
      <div className="bg-gray-800/50 rounded-lg overflow-x-auto">
        <h3 className="text-lg font-semibold p-6">Productos Más Vendidos</h3>
        <table className="w-full text-left">
          <thead className="border-b border-white/10">
            <tr>
              <th className="px-6 py-3 text-sm font-semibold">Producto</th>
              <th className="px-6 py-3 text-sm font-semibold">Categoría</th>
              <th className="px-6 py-3 text-sm font-semibold">Unidades Vendidas</th>
              <th className="px-6 py-3 text-sm font-semibold">Ingresos</th>
            </tr>
          </thead>
          <tbody>
            {productosTop.map((p, idx) => (
              <tr key={idx} className="border-b border-white/10">
                <td className="px-6 py-4 whitespace-nowrap">{p.nombre}</td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-400">{p.categoria}</td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-400">{p.unidades}</td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-400">{p.ingresos}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Reportes;
